import { render } from "./TablePagination.vue?vue&type=template&id=2185aa4f&scoped=true"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"

import "./TablePagination.vue?vue&type=style&index=0&id=2185aa4f&lang=scss&scoped=true"
import "./TablePagination.vue?vue&type=style&index=1&id=2185aa4f&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2185aa4f"]])

export default __exports__